export const emailPattern = /^[a-zA-Z0-9._%+\-'&=]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isEmail(val: string): boolean {
  return emailPattern.test(val);
}

export interface MailtoParts {
  to: readonly string[];
  cc?: readonly string[];
  bcc?: readonly string[];
  subject?: string;
  body?: string;
}

function encodeAddressList(addresses: readonly string[]): string {
  return addresses
    .map((address) => address.replace(/[%&=?#+\s]/g, (char) => encodeURIComponent(char)))
    .join(',');
}

export function buildMailtoUrl(parts: MailtoParts): string {
  const query: string[] = [];

  if (parts.cc?.length) {
    query.push(`cc=${encodeAddressList(parts.cc)}`);
  }
  if (parts.bcc?.length) {
    query.push(`bcc=${encodeAddressList(parts.bcc)}`);
  }
  if (parts.subject) {
    query.push(`subject=${encodeURIComponent(parts.subject)}`);
  }
  if (parts.body) {
    query.push(`body=${encodeURIComponent(parts.body)}`);
  }

  const target = `mailto:${encodeAddressList(parts.to)}`;
  return query.length ? `${target}?${query.join('&')}` : target;
}
